export type ApiTypeToString = {
    mpcApi: string;
    rubyApi: string;
    marketsApi: string;
    pandoraApi: string;
    enduranceApi: string;
};

export type EnvDetails = {
    authClient: string;
    rpcUrl?: string;
    mixpanelToken: string;
} & ApiTypeToString;

export enum AllowedEnv {
    Main = "MAIN", // ONLY app.loopscale.com
    Sandbox = "SANDBOX", //  ONLY sandbox.loopscale.com
    ProdTesting = "PROD_TESTING", // for simulating production with local FE
    Dev = "DEV", // run sandbox with local rust development server (apis);
    FeatureStaging = "FEATURE_STAGING", // for testing staging features in a deployed FE/BE
    Beta = "BETA" // for testing beta features with Beta backend
}

type EnvBreakdown = { main: string; sandbox: string; beta: string };

const AUTH_0_CLIENT: EnvBreakdown = {
    main: "TUAl3Yf4EDOFgwBHRpEEgsusP5Z1Q0HS",
    sandbox: "q8KJf1rrjYJDO0FqUOV4NHuegqr1jWPW",
    beta: "q8KJf1rrjYJDO0FqUOV4NHuegqr1jWPW"
};

const BASE_URL: EnvBreakdown = {
    main: "https://tars.loopscale.com/v1",
    sandbox: "https://case.loopscale.com/v1",
    beta: "https://beta.loopscale.com/v1"
};

const SERVICES: ApiTypeToString = {
    mpcApi: "mpc",
    rubyApi: "ruby",
    marketsApi: "markets",
    pandoraApi: "pandora",
    enduranceApi: "endurance"
};
// NEVER EVER CHANGE THIS, NO PROTECTION WILL BECOME PRODUCTION
const MAIN: EnvDetails = {
    ...generateApiUrls(BASE_URL.main),
    enduranceApi: "tars.loopscale.com/v1/endurance", // special case since endurance is websocket
    authClient: AUTH_0_CLIENT.main,
    mixpanelToken: "0133491c1811993bed6a4c73a82ff1a7"
};

const LOCAL_URLS = {
    mpcApi: localHost(8081),
    bsMetadataApi: localHost(8082),
    syndicatedApi: localHost(8084),
    napoleonApi: localHost(8085),
    arrakisApi: localHost(8086),
    rubyApi: localHost(8080),
    pandoraApi: localHost(80),
    marketsApi: localHost(8080)
};

// TESTING BETA IS SERVICE BY SERVICE, DEFAULT TO SANDBOX ENVIRONMENT
const BETA: EnvDetails = {
    ...generateApiUrls(BASE_URL.sandbox),
    authClient: AUTH_0_CLIENT.sandbox,
    mixpanelToken: "f29e9e947d4ec4e363d389987d742a9a",
    marketsApi: "https://markets-beta-vmyhi2huoa-uc.a.run.app/", // TODO: not high priority, but replace with customer domain from cloudflare
    pandoraApi: LOCAL_URLS.pandoraApi
};

const SANDBOX: EnvDetails = {
    ...generateApiUrls(BASE_URL.sandbox),
    authClient: AUTH_0_CLIENT.sandbox,
    mixpanelToken: "f29e9e947d4ec4e363d389987d742a9a"
};

const PROD_TESTING: EnvDetails = {
    ...MAIN,
    marketsApi: LOCAL_URLS.marketsApi
};

const FEATURE_STAGING: EnvDetails = {
    ...MAIN
};

const DEV: EnvDetails = {
    ...SANDBOX
};
export const ENVIRONMENTS = {
    [AllowedEnv.Main]: MAIN,
    [AllowedEnv.ProdTesting]: PROD_TESTING,
    [AllowedEnv.Sandbox]: SANDBOX,
    [AllowedEnv.Dev]: DEV,
    [AllowedEnv.FeatureStaging]: FEATURE_STAGING,
    [AllowedEnv.Beta]: BETA
};

function generateApiUrls(baseUrl: string) {
    const entries = Object.entries(SERVICES).map(([key, serviceName]): [keyof ApiTypeToString, string] => [
        key as keyof ApiTypeToString,
        `${baseUrl}/${serviceName}`
    ]);
    return Object.fromEntries(entries) as ApiTypeToString;
}

export function localHost(port: number) {
    const PORT_FORWARDING = false;

    if (PORT_FORWARDING) return `https://9sfrffzp-${port}.usw2.devtunnels.ms/`;
    return `http://localhost:${port}`;
}

export const DEFAULT_API_VERSION = "1.0.3";
export const SERVICE_API_VERSIONS: Partial<ApiTypeToString> = {
    marketsApi: "1.0.7"
};
